import { Popconfirm } from 'antd';
import TcInput from 'components/UI/form/input/TcInput';
import TcTextarea from 'components/UI/form/input/TcTextarea';
import BranchOrderParcelPicker from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderParcelPicker/BranchOrderParcelPicker';
import { packagingCreate } from 'global/Models/packagingModel';
import { englishNumberOnly, separator } from 'global/default';
import { ChangeEvent, FC, useCallback, useState } from 'react';
import { GoPackage } from 'react-icons/go';

interface IOrderParcelBox {
  setPackage: (_pack?: packagingCreate) => void;
  packaging: packagingCreate;
  packagingIndex: number;
  handleDelete: (_index: number) => void;
  handleCountChange: (_count: number, _index: number) => void;
  handleDescChange: (_desc: string, _index: number) => void;
  handleBarcodeChange?: (_barcodes: string[], _index: number) => void;
  isLockerReserved: boolean;
}

const BranchOrderParcelBox: FC<IOrderParcelBox> = ({
  setPackage,
  packaging,
  packagingIndex,
  handleDelete,
  handleCountChange,
  handleDescChange,
  handleBarcodeChange,
  isLockerReserved,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const toggleModal = useCallback(() => setShowModal((prevState) => !prevState), []);
  const deleteHandler = useCallback(() => handleDelete(packagingIndex), []);

  const changeCount = (count: number) => {
    handleCountChange(count, packagingIndex);
  };

  const changeDescription = (e: ChangeEvent<HTMLTextAreaElement>) => handleDescChange(e.target.value, packagingIndex);

  const changeBarcodeAtIndex = (value: string, index: number) => {
    const current = packaging.barcodes || [];
    const next = [...current];
    next[index] = value;
    handleBarcodeChange?.(next, packagingIndex);
  };

  const barcodes = packaging.barcodes || [];

  return (
    <div className={`${packaging ? 'h-full' : ''}`}>
      <div className='h-full transition-shadow lg:max-w-[380px] px-2 w-full duration-300 border rounded-lg shadow-none bg-t-bg-color hover:shadow-lg border-t-border-color-base '>
        {!packaging && (
          <span className='flex items-center justify-center w-full h-full gap-1 p-2 cursor-pointer ' onClick={toggleModal}>
            <GoPackage />
            انتخاب بسته
          </span>
        )}

        {packaging && (
          <div className='flex flex-col h-full gap-2 p-4'>
            <div className='grid gap-2 text-xs lg:grid-cols-2'>
              <div className='flex flex-col gap-1 whitespace-nowrap'>
                <span className='text-t-secondary-text-color'>عنوان : </span>
                <span>{packaging.title}</span>
              </div>

              <div className='flex flex-col gap-1 whitespace-nowrap'>
                <span className='text-t-secondary-text-color'>طول/عرض/ارتفاع : </span>
                <span>
                  {packaging.length}/{packaging.width}/{packaging.height}
                </span>
              </div>

              <div className='flex gap-2 col-span-full'>
                {packaging.weight} کیلوگرم، ارزش {separator(packaging.price)} ریال، {packaging.packagingTypeTitle}
              </div>
            </div>

            {!isLockerReserved && (
              <div className='flex flex-col items-start w-full gap-1 pt-2 mt-auto text-sm border-t whitespace-nowrap'>
                <span className='block w-full pt-1 text-xs text-t-secondary-text-color'>تعداد :</span>
                <TcInput placeholder='1' size='small' value={packaging.count} onChange={(e) => changeCount(englishNumberOnly(e.target.value))} className='w-full' />
              </div>
            )}

            {packaging.count && packaging.count > 0 && (
              <div className='flex flex-col gap-2'>
                <span className='block w-full text-xs text-t-secondary-text-color'>بارکدها :</span>

                {Array.from({ length: packaging.count || 1 }, (_, index) => (
                  <TcInput
                    key={index}
                    placeholder={`بارکد ${index + 1}`}
                    size='small'
                    value={barcodes[index] ?? ''}
                    onChange={(e) => changeBarcodeAtIndex(e.target.value, index)}
                    className='w-full'
                  />
                ))}
              </div>
            )}

            <TcTextarea placeholder='شرح سفارش' rows={1} onChange={changeDescription} value={packaging.description} autoSize />

            {!isLockerReserved && (
              <>
                <hr />
                <div className='flex items-center justify-center gap-2 pt-1'>
                  <Popconfirm title='حذف شود؟' onConfirm={deleteHandler}>
                    <span className='block text-xs text-center cursor-pointer text-t-error-color inherit-color'>حذف</span>
                  </Popconfirm>

                  <span className='block text-xs text-center cursor-pointer text-t-secondary-color inherit-color' onClick={toggleModal}>
                    ویرایش
                  </span>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      <BranchOrderParcelPicker visible={showModal} close={toggleModal} setPackage={setPackage} />
    </div>
  );
};

export default BranchOrderParcelBox;
